import { GridRows } from '../../../../interfaces/grids/GridRows'
import { AccountComment } from '../queries/PeriodReportData'

/**
 * Maps account comments from a period report to grid rows based on accountId.
 * Returns a new GridRows object with comments applied to matching rows.
 */
export const applyCommentsToGridRows = (
  gridRows: GridRows | undefined,
  comments: AccountComment[]
): GridRows | undefined => {
  if (!gridRows || !comments || comments.length === 0) {
    return gridRows
  }

  // Create a lookup map for fast comment access by accountId
  const commentMap = new Map<number, string>()
  comments.forEach((comment) => {
    commentMap.set(comment.id, comment.text)
  })

  // Clone and update prefixed data
  const updatedPrefixedData = gridRows.prefixedData.map((row) => {
    const accountId = row.accountId as number | undefined
    if (accountId && commentMap.has(accountId)) {
      return {
        ...row,
        comment: commentMap.get(accountId) || '',
      }
    }
    return row
  })

  // Clone and update emptyRowsHidden data
  const updatedEmptyRowsHidden = gridRows.emptyRowsHidden.map((row) => {
    const accountId = row.accountId as number | undefined
    if (accountId && commentMap.has(accountId)) {
      return {
        ...row,
        comment: commentMap.get(accountId) || '',
      }
    }
    return row
  })

  return {
    ...gridRows,
    prefixedData: updatedPrefixedData,
    emptyRowsHidden: updatedEmptyRowsHidden,
  }
}
